import { z } from 'zod'

import ZBaseAction from './base'

const ZPickupAction = ZBaseAction.extend({
  pickUp: z.object({
    campId: z.number().int().positive(),
  }),
})

export default ZPickupAction
